  <!-- The Modal popup-->
  <div class="dialog">
        <!-- Modal Header -->

        <div class="dialog-title">
            <h4>Appointment Confirmed<img src="assets/svg/close-white.svg" alt="close" (click)="closePop()"  ></h4>
        </div>

        <!-- Modal body -->
        <div class="content">
            <div class="row">
            <div class="col-md-1 icon-org">
                <i class="far fa-comment-dots"></i>
            </div>
            <div class="col-md-11">
                <h2>You are scheduled with Truventor member.</h2>
                <p>A calendar meeting has been sent to your email .</p>
            </div>
            </div>
            <div class="custom-form mt-1">
                <div class="row">
                <label  class="col-sm-12"> {{appoinmentsDetails?.duration}} meeting </label>
                </div>
                <div class="row">
                    <label  class="col-sm-12">{{appoinmentsDetails?.time}} / <span> India time</span> </label>
                    </div>
                    <div class="row">
                    <label  class="col-sm-12 no-mar">{{appoinmentsDetails?.name}}</label>
                    <input type="email" style="background: white;" class="form-control" disabled placeholder="{{appoinmentsDetails?.email}}">
                    </div>
            </div>
            
            <div class="clsicon row">
            <span class="img-icon">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </span>
            
            <span class="cls-ist">
            Ut wisi enim ad minim veniam, quis nostrud exercitation ullamcorper suscipit lobortis nisi ut aliquip exea commodo consequat.</span>
            </div>
        </div>
    </div>

      <!--end modal popup-->
